import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ChangePasswordService } from '../../services/ChangePasswordService';
import * as BullCache from "../../util/BullCache";
import "../custom.css";
import { useNavigate } from "react-router-dom";

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [displayCurrent, setDisplayCurrent] = useState('');
  const [displayNew, setDisplayNew] = useState('');
  const [displayConfirm, setDisplayConfirm] = useState('');

  const currentTimeoutRef = useRef(null);
  const newTimeoutRef = useRef(null);
  const confirmTimeoutRef = useRef(null);

  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const navigate = useNavigate();

  const user = BullCache.getFromCache("user");

  const validatePasswordLength = (password) => {
    return password.length >= 4 && password.length <= 10;
  };

  const handleMaskedInput = (e, realValue, setReal, setDisplay, timeoutRef) => {
    const inputValue = e.target.value;
    const prevLength = realValue.length;
    const newLength = inputValue.length;

    if (newLength < prevLength) {
      // Backspace or delete
      setReal(realValue.slice(0, newLength));
      setDisplay('*'.repeat(newLength));
      return;
    }

    const newChar = inputValue.charAt(inputValue.length - 1);
    const updatedRealValue = realValue + newChar;

    setReal(updatedRealValue);
    setDisplay('*'.repeat(updatedRealValue.length - 1) + newChar);

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setDisplay('*'.repeat(updatedRealValue.length));
    }, 800);
  };

  useEffect(() => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('Please fill in all fields.');
      setIsButtonDisabled(true);
      return;
    }

    if (!validatePasswordLength(currentPassword) ||
      !validatePasswordLength(newPassword) ||
      !validatePasswordLength(confirmPassword)) {
      setError('Password must be between 4 and 10 characters.');
      setIsButtonDisabled(true);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New password and confirm password must match.');
      setIsButtonDisabled(true);
      return;
    }

    setIsButtonDisabled(false);
    setError('');
  }, [currentPassword, newPassword, confirmPassword]);

  const handleSubmit = () => {
    const password = {
      adminId: user.adminId,
      oldPassword: currentPassword,
      newPassword: newPassword
    };

    ChangePasswordService.changepassword(password).then(res => {
      try {
        setSuccessMessage(res.message || 'Password changed successfully!');
        setIsButtonDisabled(true);
        setError('');

        setTimeout(() => {
          navigate("/dashboard");
        }, 500);
      } catch (error) {
        setError(error.message || 'An error occurred. Please try again.');
        setSuccessMessage('');
      }
    });
  };

  return (
    <Card>
      <Card.Header className="fss-1">Change Password</Card.Header>
      <Card.Body>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <Form>
          {/* Current Password */}
          <Form.Group as={Row} className="mb-3 fss-09">
            <Form.Label column sm="2">
              Current Password <b style={{ fontSize: '0.9rem', color: 'red' }}>*</b>
            </Form.Label>
            <Col sm="4">
              <Form.Control
                type="text"
                placeholder="Enter Password"
                className="white-background text-black big-dot"
                id="currentPassword"
                value={displayCurrent}
                onChange={(e) =>
                  handleMaskedInput(e, currentPassword, setCurrentPassword, setDisplayCurrent, currentTimeoutRef)
                }
                required
                autoComplete="off"
              />
            </Col>
          </Form.Group>

          {/* New Password */}
          <Form.Group as={Row} className="mb-3 fss-09">
            <Form.Label column sm="2">
              New Password <b style={{ fontSize: '0.9rem', color: 'red' }}>*</b>
            </Form.Label>
            <Col sm="4">
              <Form.Control
                type="text"
                placeholder="Enter New Password"
                className="white-background text-black big-dot"
                id="newPassword"
                value={displayNew}
                onChange={(e) =>
                  handleMaskedInput(e, newPassword, setNewPassword, setDisplayNew, newTimeoutRef)
                }
                required
                autoComplete="off"
              />
            </Col>
          </Form.Group>

          {/* Confirm Password */}
          <Form.Group as={Row} className="mb-3 fss-09">
            <Form.Label column sm="2">
              Confirm Password <b style={{ fontSize: '0.9rem', color: 'red' }}>*</b>
            </Form.Label>
            <Col sm="4">
              <Form.Control
                type="text"
                placeholder="Enter Confirm Password"
                className="white-background text-black big-dot"
                id="confirmPassword"
                value={displayConfirm}
                onChange={(e) =>
                  handleMaskedInput(e, confirmPassword, setConfirmPassword, setDisplayConfirm, confirmTimeoutRef)
                }
                required
                autoComplete="off"
              />
            </Col>
          </Form.Group>

          {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}

          <Row className="d-flex justify-content">
            <Col xl={2} md={2}></Col>
            <Col xl={2} md={2} xs={6} className='text-center'>
              <Button
                variant="success"
                className="mt-0 w-100"
                disabled={isButtonDisabled}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default ChangePassword;
